import axios from 'axios';
import { RoutePaths } from 'Interfaces/RoutePaths';
import StorageService from 'Services/Storage';
import { API_URL } from 'Utils/constants';

const availableRoutesForTemporaryUser = [
  RoutePaths.LANDING_SIGNUP,
  RoutePaths.LANDING_SIGNUP_CONFIRM,
  RoutePaths.LANDING_SIGNUP_THANKS,
];

export default async (accessToken, optHeaders = {}) => {
  const headers: Record<string, string> = {
    ...optHeaders,
  };

  const tempToken = StorageService.getAccessToken('tempToken');

  const isTempFlow = availableRoutesForTemporaryUser.includes(window.location.pathname);

  if (tempToken && isTempFlow) {
    headers.authorization = `Bearer ${tempToken}`;
  }

  // fallback to JWT for old users
  else if (accessToken || StorageService.getAccessToken()) {
    const token = accessToken || StorageService.getAccessToken();

    headers.authorization = `Bearer ${token}`;
  }

  return axios.create({
    headers,
    withCredentials: !isTempFlow,
    baseURL: API_URL,
  });
};
